import { TourActions } from '../../tour/constants'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/merge'
import 'rxjs/add/operator/switchMap'
import { Observable } from 'rxjs/Rx'
import { Map } from 'immutable'
import { setScene } from '../actions/common'
import { CommonActionTypes } from '../constants'
import { setDragHintDetails } from '../actions/common'
import {
    setDragHintDetails as setPanoramaDragHintDetails,
    SET_DRAG_HINT_DETAILS as PANORAMA_SET_DRAG_HINT_DETAILS,
} from 'aria-viewer/players/panoplayer/actions/panoramaActions'
import {
    setDragHintDetails as setVideoDragHintDetails,
    SET_DRAG_HINT_DETAILS as VIDEO_SET_DRAG_HINT_DETAILS,
    DRAGGING_HINT_MOUNTED,
} from 'aria-viewer/players/videoplayer/actions/videoActions'
import { STOP_LIST_DRAWER, STOP_DESCRIPTION_DRAWER } from 'aria-viewer/drawer/drawerMenuActions'
import { isReduxBatch } from 'aria-viewer/utils/epicsCommon'

export default (action$, state$) => {
    const stopChanged$ = action$.ofType(TourActions.STOP_CHANGED)

    const tourEmbedExpand$ = action$.ofType(TourActions.SET_TOUR_EMBED_EXPANDED)

    const setScene$ = stopChanged$
        .map(action => action.current)
        .map(({ stopid, main_media_id, main_media_type }) => {
            let mediaKey = main_media_type + 's'
            switch (main_media_type) {
                case 'photo':
                    mediaKey = 'photoMain'
                    break
                case 'video':
                    mediaKey = 'videoMain'
                    break
            }
            const scene = state$.getState().getIn(['interactiveElements', mediaKey, 'byId', String(main_media_id)])
            return Map({
                stopId: stopid,
                scene,
            })
        })
        .map(scene => setScene(scene))

    const isIntroVideoPlayed$ = action$.filter(
        action =>
            isReduxBatch(action) &&
            action.payload.some(element => element.type === TourActions.SET_IS_STOP_INTRO_PLAYED)
    )

    const interactiveElementsDraggingHintSetVisible$ = action$
        .ofType(CommonActionTypes.OPEN_MODAL)
        .mapTo(setDragHintDetails({ isVisible: true }))

    const interactiveElementsDraggingHintResetVisible$ = action$
        .ofType(CommonActionTypes.SET_DRAG_HINT_DETAILS)
        .filter(action => action.draggingHint.get('isVisible'))
        .switchMap(action =>
            Observable.of(action)
                .delay(state$.getState().getIn(['interactiveElements', 'draggingHint', 'delay']))
                .mapTo(setDragHintDetails({ isVisible: false }))
        )

    const panoDraggingHintSetVisible$ = Observable.merge(stopChanged$, isIntroVideoPlayed$, tourEmbedExpand$).map(_ => {
        const isResponseiveUI = state$.getState().getIn(['device', 'useResponsiveUI'])
        const isDeviceMobile = state$.getState().getIn(['device', 'isDeviceMobile']) !== null
        const isEmbedExpanded = state$.getState().getIn(['tour', 'isEmbedExpanded'])

        const hintText = isDeviceMobile && isResponseiveUI && !isEmbedExpanded ? 'Tap to go fullscreen' : undefined

        return setPanoramaDragHintDetails({ isVisible: true, hintText })
    })

    const panoDraggingHintResetVisible$ = action$
        .ofType(PANORAMA_SET_DRAG_HINT_DETAILS)
        .filter(action => action.draggingHint.get('isVisible'))
        .switchMap(action =>
            Observable.of(action)
                .delay(state$.getState().getIn(['panorama', 'draggingHint', 'delay']))
                .mapTo(setPanoramaDragHintDetails({ isVisible: false }))
        )

    const drawers$ = action$
        .ofType(STOP_LIST_DRAWER, STOP_DESCRIPTION_DRAWER)
        .filter(_ => state$.getState().getIn(['panorama', 'draggingHint', 'isVisible']))
        .mapTo(setPanoramaDragHintDetails({ isVisible: false }))

    const videoDraggingHintSetVisible$ = action$
        .ofType(DRAGGING_HINT_MOUNTED)
        .mapTo(setVideoDragHintDetails({ isVisible: true }))

    const videoDraggingHintResetVisible$ = action$
        .ofType(VIDEO_SET_DRAG_HINT_DETAILS)
        .filter(action => action.draggingHint.get('isVisible'))
        .switchMap(action =>
            Observable.of(action)
                .delay(state$.getState().getIn(['video', 'draggingHint', 'delay']))
                .mapTo(setVideoDragHintDetails({ isVisible: false }))
        )

    return Observable.merge(
        drawers$,
        panoDraggingHintSetVisible$,
        panoDraggingHintResetVisible$,
        interactiveElementsDraggingHintSetVisible$,
        interactiveElementsDraggingHintResetVisible$,
        videoDraggingHintSetVisible$,
        videoDraggingHintResetVisible$,
        setScene$
    )
}
